import React from 'react';
import Hero from './Hero';
import Fancy from './Fancy';
import Location from './Location';
import Map from "./Location/Map";
import Ourteam from './Ourteam';


const About = () => {
 return (
   <div>
     <Hero />
     <Fancy />
     <Ourteam />
     <Map />
   </div>
 )
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.js